module.exports = __webpack_public_path__ + "img/market.fca3fae1.png";